"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationButton = exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BaseButton = require("@instructure/ui-buttons/lib/BaseButton");

var _omitProps = require("@instructure/ui-react-utils/lib/omitProps.js");

var _testable = require("@instructure/ui-testable/lib/testable.js");

var _dec, _class, _class2, _temp;

/**
---
parent: Pagination
id: Pagination.Page
---
**/
var PaginationButton = (_dec = (0, _testable.testable)(), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PaginationButton, _Component);

  var _super = (0, _createSuper2.default)(PaginationButton);

  function PaginationButton() {
    (0, _classCallCheck2.default)(this, PaginationButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PaginationButton, [{
    key: "render",
    value: function render() {
      var exclude = this.props.current ? ['onClick', 'href'] : [];
      var props = (0, _omitProps.omitProps)(this.props, PaginationButton.propTypes, exclude);
      return /*#__PURE__*/_react.default.createElement(_BaseButton.BaseButton, Object.assign({
        color: "primary",
        withBackground: this.props.current ? true : false,
        withBorder: this.props.current ? true : false
      }, props, {
        "aria-current": this.props.current ? 'page' : null
      }), this.props.children);
    }
  }]);
  PaginationButton.displayName = "PaginationButton";
  return PaginationButton;
}(_react.Component), _class2.propTypes = {
  /**
   * Content to render as page selection
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Whether the page is currently displayed
   */
  current: _propTypes.default.bool
}, _class2.defaultProps = {
  current: false
}, _temp)) || _class);
exports.PaginationButton = PaginationButton;
var _default = PaginationButton;
exports.default = _default;